/**
 * Account roles and the staff/external distinction they encode.
 *
 * "admin" and "user" are both BOI *staff*: "user" is the internal default and
 * carries access to the expert review surface; "admin" adds the admin console on
 * top. "external" is the public-signup default: an outside visitor who can run
 * assessments and read their own reports, but never sees the staff surface.
 *
 * The backend owns the authoritative check; this predicate mirrors it so the
 * router guards and nav can gate the staff surface consistently.
 */
export type Role = "admin" | "user" | "external";

/** True for BOI staff (admin or internal user); false for external signups. */
export function isStaffRole(role: string | null | undefined): boolean {
  return role === "admin" || role === "user";
}
